import { ExportSuccessModal } from "@components";

type VehiclesExportModalProps = {
	isOpen: boolean;
	onClose: () => void;
	message?: string | null;
};

export function VehiclesExportModal({
	isOpen,
	onClose,
	message,
}: VehiclesExportModalProps) {
	return (
		<ExportSuccessModal
			isOpen={isOpen}
			message={message}
			onClose={onClose}
		/>
	);
}
